import ScoreDisplays from "./ScoreDisplays.tsx";
import NewGameButton from "./NewGameButton.tsx";
import {cn} from "../../util.ts";
import {LightbulbFilament} from "@phosphor-icons/react";
import {Dispatch, SetStateAction, useEffect, useState} from "react";

function useLang(): 'zh' | 'en' {
    const [lang, setLang] = useState<'zh' | 'en'>(() => {
        try {
            const saved = localStorage.getItem('games-site-lang');
            if (saved === 'zh' || saved === 'en') return saved;
        } catch (e) {}
        return (navigator.language || 'zh').toLowerCase().indexOf('zh') === 0 ? 'zh' : 'en';
    });
    useEffect(() => {
        const onChange = () => {
            try {
                const saved = localStorage.getItem('games-site-lang');
                if (saved === 'zh' || saved === 'en') setLang(saved);
            } catch (e) {}
        };
        window.addEventListener('games-i18n-change', onChange);
        return () => window.removeEventListener('games-i18n-change', onChange);
    }, []);
    return lang;
}

interface GameHeaderProps {
    setGameMatrix: Function;
    size: number;
    currentScore: number;
    setCurrentScore: Function;
    highScore: number;
    setHighScore: Function;
    setIsGameOver: Function;
    setShowModal: Dispatch<SetStateAction<boolean>>;
}

export default function GameHeader({setGameMatrix, size, currentScore, setCurrentScore, highScore, setHighScore, setIsGameOver, setShowModal}:GameHeaderProps) {
    const lang = useLang();
    const zh = lang === 'zh';
    return <div className="flex flex-col items-center mt-6 mb-6 z-20 w-full gap-6 sm:gap-4">
        <div className={cn("flex flex-col sm:flex-row gap-8 sm:gap-0 items-center w-full")}>
            <h1 className="font-extrabold text-7xl ml-4 extra-glowy-text">3072</h1>
            <ScoreDisplays currentScore={currentScore} highScore={highScore} setHighScore={setHighScore}/>
        </div>
        <div className={"flex flex-row items-center sm:justify-end justify-center w-full gap-2"}>
            <button data-ui-chrome="1" onClick={() => setShowModal(true)} title={zh ? '查看帮助' : 'View help'} className={"px-2.5 py-1 flex items-center gap-1 border border-white/20 rounded-lg"}>
                <span className={"extra-glowy-text"}><LightbulbFilament className={"extra-glowy-text"} weight={"bold"} size={"1.3rem"}/></span>
                <span className={"extra-glowy-text text-sm"}>{zh ? '帮助' : 'Help'}</span>
            </button>
            <NewGameButton setGameMatrix={setGameMatrix} size={size} setCurrentScore={setCurrentScore} setIsGameOver={setIsGameOver}/>
        </div>
    </div>
}